import React from 'react';
import { createRoot } from 'react-dom/client';
import 'animate.css/animate.min.css';
import App from './js/client.jsx';
import { getAppSurface, track } from './js/analytics.js';

if (typeof window !== 'undefined') {
  window.__focusTodoDeferredInstallPrompt = null;
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    window.__focusTodoDeferredInstallPrompt = event;
    track('pwa_install_prompt_available', {
      app_surface: getAppSurface(),
    });
    window.dispatchEvent(new Event('focustodo:installpromptready'));
  });
}

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`).catch(() => {
      // Ignore registration errors; app still works without offline support.
    });
  });
}
